import { ConvertUrlToFile } from '@/common/utils/ConvertUrlToFile';
import { fetchApi } from '@/config/axiosSetting';
import { PostDamagedAdjusterDocumentImagesQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postDamagedAdjusterDocumentImages/postDamagedAdjusterDocumentImagesQuery.type';

export const postDamagedAdjusterDocumentImagesFunction = (
  params: PostDamagedAdjusterDocumentImagesQueryParamsType,
) => {
  const data = new FormData();
  const image = ConvertUrlToFile(params.data?.image, 'image', 'image');
  data.append('image', image);

  data.append('title', params.data?.title);

  const generateUrl = () => {
    switch (params.type) {
      case 'damaged':
        return `/property/reports/${params.id}/accident_users/damaged/images/adjuster/document/`;

      case 'body':
        return `/body/reports/${params.id}/images/adjuster/document/`;

      case 'culprit':
        return `/property/reports/${params.id}/accident_users/culprit/images/adjuster/document/`;

      case 'initial':
        return `/initial/reports/${params?.id}/images/adjuster/document/`;
    }
  };

  return fetchApi({
    method: 'post',
    url: generateUrl(),
    data,
    params:
      params.type === 'damaged' ? { damaged_id: params?.damagedId } : undefined,
  });
};
